<footer class="bg-stone-bg mt-10">
  <div class="max-w-container-max mx-auto py-section-gap px-margin-mobile grid grid-cols-1 md:grid-cols-4 gap-10 border-t border-outline-variant">
    <div>
      <div class="flex items-center gap-2 mb-3">
        <img src="assets/icons/logo-nav.png" alt="Chambia" width="28" height="28" class="w-7 h-7">
        <span class="text-2xl font-extrabold text-primary">Chambia</span>
      </div>
      <p class="text-slate-muted text-sm max-w-xs">
        El marketplace de empleo WhatsApp-first para LATAM. Conectamos talento con empresas usando IA.
      </p>
    </div>

    <div>
      <h3 class="font-bold text-sm uppercase tracking-wide text-on-surface-variant mb-4">Candidatos</h3>
      <ul class="flex flex-col gap-2 text-sm">
        <li><a routerLink="/" class="text-slate-muted hover:text-primary transition-colors">Cómo funciona</a></li>
        <li><a routerLink="/vacantes" class="text-slate-muted hover:text-primary transition-colors">Buscar vacantes</a></li>
      </ul>
    </div>

    <div>
      <h3 class="font-bold text-sm uppercase tracking-wide text-on-surface-variant mb-4">Empresas</h3>
      <ul class="flex flex-col gap-2 text-sm">
        <li><a routerLink="/empresas" class="text-slate-muted hover:text-primary transition-colors">Planes y precios</a></li>
        <li><a routerLink="/empresas" class="text-slate-muted hover:text-primary transition-colors">Solicita una demo</a></li>
      </ul>
    </div>

    <div>
      <h3 class="font-bold text-sm uppercase tracking-wide text-on-surface-variant mb-4">Legal</h3>
      <ul class="flex flex-col gap-2 text-sm">
        <li><a routerLink="/terminos" class="text-slate-muted hover:text-primary transition-colors">Términos y condiciones</a></li>
        <li><a routerLink="/privacidad" class="text-slate-muted hover:text-primary transition-colors">Política de privacidad</a></li>
      </ul>
    </div>
  </div>

  <div class="max-w-container-max mx-auto px-margin-mobile pb-8 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-slate-muted">
    <span>© {{ year }} Chambia. Hecho en LATAM.</span>
    <span>México · Colombia · Ecuador · Costa Rica · Perú · Argentina · Chile · Panamá · Uruguay · Rep. Dominicana · Guatemala</span>
  </div>

  <div class="h-20 md:hidden"></div>
</footer>
